module.exports = __webpack_public_path__ + "img/Monte_Kope_24.b8bc608a.jpg";